import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-not-found',
  templateUrl: './home-not-found.component.html',
  styleUrls: ['./home-not-found.component.css']
})
export class HomeNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
